<template>
  <v-card flat>
    <v-card-title>
      <v-tabs v-model="tabs" grow>
        <v-tab>درخواست های کاربر</v-tab>
        <v-tab>درخواست های برداشت از حساب</v-tab>
      </v-tabs>
    </v-card-title>

    <v-card-text>
      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <div class="row">
            <div class="col-md-12 p-5">
              <data-table
                  :columns="columns"
                  :data="userInfo"
                  :per-page="[10, 25, 50, 100, 200, 400]"
                  :translate="translate"
                  orderDir="desc"
                  @on-table-props-changed="reloadTable"
              />
            </div>
          </div>
        </v-tab-item>

        <v-tab-item>
          <admin-transfer-requests/>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import {SET_BREADCRUMB} from "../../../../core/services/store/breadcrumbs.module";
import Btn from "./Btn";
import AdminTransferRequests from "../transferRequest/Index";
import TableStatus from "@/view/pages/admin/confirm/TableStatus.vue";

export default {
  components: {AdminTransferRequests},
  data() {
    return {
      translate: {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      },
      url: "authRequest",
      userInfo: {},
      tabs: 0,
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      columns: [
        {
          label: "شناسه",
          name: "id",
          orderable: true,
          colStyle: "width: 100px;",
        },
        {
          label: "نام",
          name: "name",
          orderable: true,
        },
        {
          label: "نام خانوادگی",
          name: "lastName",
          orderable: true,
        },
        {
          label: "نام کاربری",
          name: "username",
          orderable: true,
        },
        {
          label: "کد ملی",
          name: "nid",
        },
        {
          label: "وضعیت",
          name: "auth_validate",
          component:TableStatus
        },
        {
          label: "تلفن",
          name: "phone",
          orderable: true,
        },
        {
          label: "تاریخ درخواست",
          name: "updated_at",
          transform: (val) => {
            return this.$options.filters.longDate(val.data.updated_at);
          },
        },
        {
          label: "نوع کاربر",
          name: "type",
          orderable: true,
          transform: (value, data) => {
            return value.data.type === "regular" ? "شخص حقیقی" : "شخص حقوقی";
          },
        },
        {
          label: "عملیات",
          name: "actions",
          component: Btn,
          handler: this.showItem,
          event: "showItem",
          meta: {
            permission_prefix: "user_",
          },
        },
      ],
    };
  },

  created() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: this.$t(this.$route.meta.title)},
    ]);
    this.getUserInfo(this.url);
  },

  methods: {
    filterOnlyCapsText(value, search, item) {
      return (
          value != null &&
          search != null &&
          typeof value === "string" &&
          value.toString().toLocaleUpperCase().indexOf(search) !== -1
      );
    },

    getUserInfo(url = this.url, params = this.tableProps) {
      this.requestApiGet(url, params).then((response) => {
        this.userInfo = response.data;
      });
    },

    reloadTable(params) {
      this.getUserInfo(this.url, params);
    },

    showItem(data) {
      this.$router.push({
        name: "user.confirmed.show",
        params: {id: data.id},
      });
    },
  },
};
</script>
